import React from "react";
import PaidSubscriptionDetails from "./PaidSubscriptionDetails";
import ReadOnlySubscriptionDetails from "./ReadOnlySubscriptionDetails";
import FreeSubscriptionDetails from "./FreeSubscriptionDetails";
import TrialSubscriptionDetails from "./TrialSubscriptionDetails";
import { NotImplementedSubscription } from "../Components/CommonPanelContent";
import DetailViewPanel from "components/panels/DetailViewPanel";

interface Props {
  activeSubscription: server.dto.Subscription
  nextSubscriptionType: server.dto.SubscriptionType
  nextBillingCycle: server.dto.BillingCycle
  discountUntil?: Date
  discountPercentage?: server.dto.Percentage
  enabledInternalUsers: number
}

const PanelContent = (props: Props) => {
  switch (props.activeSubscription.type) {
    case "trial":
    case "trialEnd":
      return (<TrialSubscriptionDetails {...props} />);
    case "free":
      return (<FreeSubscriptionDetails {...props} />);
    case "paid":
      return (<PaidSubscriptionDetails {...props} />);
    case "readOnly":
      return (<ReadOnlySubscriptionDetails {...props} />);
    default:
      return (<NotImplementedSubscription />);
  }
};

const SubscriptionDetailsPanel = (props: Props) => (
  <DetailViewPanel
    title={RESX.Subscription.resxSubscription}>
    <div className="content-section">
      <PanelContent {...props} />
    </div>
  </DetailViewPanel>
);

export default SubscriptionDetailsPanel;
